import { c as _c } from "react/compiler-runtime";
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { Fragment } from 'react';
import { parseVaultDescriptionLinks } from './parseVaultDescriptionLinks';
interface LinkifiedTextProps {
  text: string;
}

/**
 * Renders `text` inline, turning plain-text URLs into external links. Adds no
 * wrapper element and no color/size classes of its own, so links inherit the
 * surrounding element's typography.
 */
export const LinkifiedText = t0 => {
  const $ = _c(4);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    const segments = parseVaultDescriptionLinks(text);
    t1 = segments.map(_temp);
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(segment, index) {
  return <Fragment key={`${segment.type}-${index}`}>{segment.type === "link" ? <ExternalLink href={segment.href} underlined={true}>{segment.text}</ExternalLink> : segment.text}</Fragment>;
}